export const INVESTIGATION_VITALS = "vitals";
export const BLOOD_PRESSURE_SYSTOLIC = "systolic";
export const BLOOD_PRESSURE_DIASTOLIC = "diastolic";
export const BLOOD_PRESSURE_METRICS = [
  BLOOD_PRESSURE_SYSTOLIC,
  BLOOD_PRESSURE_DIASTOLIC,
];

export const PAYERS_OPTIONS = [
  { value: "Patient/Guardian", label: "Patient/Guardian" },
  { value: "NHIF", label: "NHIF" },
  { value: "Linda Mama", label: "Linda Mama" },
  { value: "UHC", label: "UHC" },
  { value: "Exemption", label: "Exempt" },
  { value: "Waiver", label: "Waiver" },
];

export const OUTPATIENT_TYPE = "Outpatient";
export const INPATIENT_TYPE = "Inpatient";

export const GENDER_CODES = {
  MALE: "m",
  FEMALE: "f",
  TRANSGENDER: "transgender",
};

export const MARITAL_STATUS_CODES = {
  UNKNOWN: "UNK",
  SINGLE: "U",
  MARRIED: "M",
  DIVORCED: "L",
  WIDOWED: "W",
};

export const NEXT_OF_KIN_RELATIONSHIP_CODES = {
  HUSBAND: "husband",
  WIFE: "wife",
  BROTHER: "brother",
  SISTER: "sister",
  FATHER: "father",
  MOTHER: "mother",
  CHILD: "child",
  FRIEND: "friend",
  OTHER: "other",
};

export const COUNTRY_CODES = {
  KENYA: "KE",
  LEBANON: "LB",
  GHANA: "GH",
  NIGERIA: "NG",
  SYRIA: "SY",
  IRAQ: "IQ",
  UK: "GB",
  SOMALIA: "SO",
  AFGHANISTAN: "AF",
  ÅLAND_ISLANDS: "AX",
  ALBANIA: "AL",
  ALGERIA: "DZ",
  AMERICAN_SAMOA: "AS",
  ANDORRA: "AD",
  ANGOLA: "AO",
  ANGUILLA: "AI",
  ANTARCTICA: "AQ",
  ANTIGUA_AND_BARBUDA: "AG",
  ARGENTINA: "AR",
  ARMENIA: "AM",
  ARUBA: "AW",
  AUSTRALIA: "AU",
  AUSTRIA: "AT",
  AZERBAIJAN: "AZ",
  BAHAMAS: "BS",
  BAHRAIN: "BH",
  BANGLADESH: "BD",
  BARBADOS: "BB",
  BELARUS: "BY",
  BELGIUM: "BE",
  BELIZE: "BZ",
  BENIN: "BJ",
  BERMUDA: "BM",
  BHUTAN: "BT",
  BOLIVIA: "BO",
  BOSNIA_AND_HERZEGOVINA: "BA",
  BOTSWANA: "BW",
  BOUVET_ISLAND: "BV",
  BRAZIL: "BR",
  BRITISH_INDIAN_OCEAN_TERRITORY: "IO",
  BRUNEI_DARUSSALAM: "BN",
  BULGARIA: "BG",
  BURKINA_FASO: "BF",
  BURUNDI: "BI",
  CAMBODIA: "KH",
  CAMEROON: "CM",
  CANADA: "CA",
  CAPE_VERDE: "CV",
  CAYMAN_ISLANDS: "KY",
  CENTRAL_AFRICAN_REPUBLIC: "CF",
  CHAD: "TD",
  CHILE: "CL",
  CHINA: "CN",
  CHRISTMAS_ISLAND: "CX",
  COCOS_ISLANDS: "CC",
  COLOMBIA: "CO",
  COMOROS: "KM",
  CONGO: "CG",
  THE_DEMOCRATIC_REPUBLIC_OF_THE_CONGO: "CD",
  COOK_ISLANDS: "CK",
  COSTA_RICA: "CR",
  COTE_D_IVOIRE: "CI",
  CROATIA: "HR",
  CUBA: "CU",
  CYPRUS: "CY",
  CZECH_REPUBLIC: "CZ",
  DENMARK: "DK",
  DJIBOUTI: "DJ",
  DOMINICA: "DM",
  DOMINICAN_REPUBLIC: "DO",
  ECUADOR: "EC",
  EGYPT: "EG",
  EL_SALVADOR: "SV",
  EQUATORIAL_GUINEA: "GQ",
  ERITREA: "ER",
  ESTONIA: "EE",
  ETHIOPIA: "ET",
  FALKLAND_ISLANDS: "FK",
  FAROE_ISLANDS: "FO",
  FIJI: "FJ",
  FINLAND: "FI",
  FRANCE: "FR",
  FRENCH_GUIANA: "GF",
  FRENCH_POLYNESIA: "PF",
  FRENCH_SOUTHERN_TERRITORIES: "TF",
  GABON: "GA",
  GAMBIA: "GM",
  GEORGIA: "GE",
  GERMANY: "DE",
  GIBRALTAR: "GI",
  GREECE: "GR",
  GREENLAND: "GL",
  GRENADA: "GD",
  GUADELOUPE: "GP",
  GUAM: "GU",
  GUATEMALA: "GT",
  GUERNSEY: "GG",
  GUINEA: "GN",
  GUINEA_BISSAU: "GW",
  GUYANA: "GY",
  HAITI: "HT",
  HEARD_ISLAND_AND_MCDONALD_ISLANDS: "HM",
  HOLY_SEE: "VA",
  HONDURAS: "HN",
  HONG_KONG: "HK",
  HUNGARY: "HU",
  ICELAND: "IS",
  INDIA: "IN",
  INDONESIA: "ID",
  IRAN: "IR",
  IRELAND: "IE",
  ISLE_OF_MAN: "IM",
  ISRAEL: "IL",
  ITALY: "IT",
  JAMAICA: "JM",
  JAPAN: "JP",
  JERSEY: "JE",
  JORDAN: "JO",
  KAZAKHSTAN: "KZ",
  KIRIBATI: "KI",
  NORTH_KOREA: "KP",
  KOREA: "KR",
  KUWAIT: "KW",
  KYRGYZSTAN: "KG",
  LAO: "LA",
  LATVIA: "LV",
  LESOTHO: "LS",
  LIBERIA: "LR",
  LIBYA: "LY",
  LIECHTENSTEIN: "LI",
  LITHUANIA: "LT",
  LUXEMBOURG: "LU",
  MACAO: "MO",
  MACEDONIA: "MK",
  MADAGASCAR: "MG",
  MALAWI: "MW",
  MALAYSIA: "MY",
  MALDIVES: "MV",
  MALI: "ML",
  MALTA: "MT",
  MARSHALL_ISLANDS: "MH",
  MARTINIQUE: "MQ",
  MAURITANIA: "MR",
  MAURITIUS: "MU",
  MAYOTTE: "YT",
  MEXICO: "MX",
  MICRONESIA: "FM",
  MOLDOVA: "MD",
  MONACO: "MC",
  MONGOLIA: "MN",
  MONTSERRAT: "MS",
  MOROCCO: "MA",
  MOZAMBIQUE: "MZ",
  MYANMAR: "MM",
  NAMIBIA: "NA",
  NAURU: "NR",
  NEPAL: "NP",
  NETHERLANDS: "NL",
  NETHERLANDS_ANTILLES: "AN",
  NEW_CALEDONIA: "NC",
  NEW_ZEALAND: "NZ",
  NICARAGUA: "NI",
  NIGER: "NE",
  NIUE: "NU",
  NORFOLK_ISLAND: "NF",
  NORTHERN_MARIANA_ISLANDS: "MP",
  NORWAY: "NO",
  OMAN: "OM",
  PAKISTAN: "PK",
  PALAU: "PW",
  PALESTINE: "PS",
  PANAMA: "PA",
  PAPUA_NEW_GUINEA: "PG",
  PARAGUAY: "PY",
  PERU: "PE",
  PHILIPPINES: "PH",
  PITCAIRN: "PN",
  POLAND: "PL",
  PORTUGAL: "PT",
  PUERTO_RICO: "PR",
  QATAR: "QA",
  REUNION: "RE",
  ROMANIA: "RO",
  RUSSIA: "RU",
  RWANDA: "RW",
  SAINT_HELENA: "SH",
  SAINT_KITTS_AND_NEVIS: "KN",
  SAINT_LUCIA: "LC",
  SAINT_PIERRE_AND_MIQUELON: "PM",
  SAINT_VINCENT_AND_THE_GRENADINES: "VC",
  SAMOA: "WS",
  SAN_MARINO: "SM",
  SAO_TOME_AND_PRINCIPE: "ST",
  SAUDI_ARABIA: "SA",
  SENEGAL: "SN",
  SERBIA_AND_MONTENEGRO: "CS",
  SEYCHELLES: "SC",
  SIERRA_LEONE: "SL",
  SINGAPORE: "SG",
  SLOVAKIA: "SK",
  SLOVENIA: "SI",
  SOLOMON_ISLANDS: "SB",
  SOUTH_AFRICA: "ZA",
  SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS: "GS",
  SPAIN: "ES",
  SRI_LANKA: "LK",
  SUDAN: "SD",
  SURINAME: "SR",
  SVALBARD_AND_JAN_MAYEN: "SJ",
  SWAZILAND: "SZ",
  SWEDEN: "SE",
  SWITZERLAND: "CH",
  TAIWAN: "TW",
  TAJIKISTAN: "TJ",
  TANZANIA: "TZ",
  THAILAND: "TH",
  TIMOR_LESTE: "TL",
  TOGO: "TG",
  TOKELAU: "TK",
  TONGA: "TO",
  TRINIDAD_AND_TOBAGO: "TT",
  TUNISIA: "TN",
  TURKEY: "TR",
  TURKMENISTAN: "TM",
  TCI: "TC",
  TUVALU: "TV",
  UGANDA: "UG",
  UKRAINE: "UA",
  UAE: "AE",
  US: "US",
  UM: "UM",
  URUGUAY: "UY",
  UZBEKISTAN: "UZ",
  VANUATU: "VU",
  VENEZUELA: "VE",
  VIETNAM: "VN",
  BVGI: "VG",
  USVI: "VI",
  WF: "WF",
  WSAHARA: "EH",
  YEMEN: "YE",
  ZAMBIA: "ZM",
  ZIMBABWE: "ZW",
  OTHER: "OT",
};

export const PAYMENT_METHODS = {
  CASH: "Cash",
};

export const CURRENCY_BASE_DEFAULT = 10;
export const DECIMALS_PLACES_DEFAULT = 2;

export const TERRITORY = {
  KENYA: "kenya",
  NIGERIA: "nigeria",
  PAKISTAN: "pakistan",
  LIBERIA: "liberia",
} as const;

export const countryCodeToTerritory = {
  KE: TERRITORY.KENYA,
  NG: TERRITORY.NIGERIA,
  PK: TERRITORY.PAKISTAN,
  LR: TERRITORY.LIBERIA,
};

export const territoryToCountryCode = {
  [TERRITORY.KENYA]: COUNTRY_CODES.KENYA,
  [TERRITORY.NIGERIA]: COUNTRY_CODES.NIGERIA,
  [TERRITORY.PAKISTAN]: COUNTRY_CODES.PAKISTAN,
  [TERRITORY.LIBERIA]: COUNTRY_CODES.LIBERIA,
};

export const MEDIA_QUERY_SMALL_DEVICE = "(max-width:600px)";
